import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";


export class BuffaloReelAreaView extends ReelAreaView {

    private _baseMask:PIXI.Graphics;

    constructor(resourcesGroup?:ResourcesGroupName) {
        super(resourcesGroup);
    }

    protected onResize(resizeData:IResizeData):void {

        //debugger;
        if(resizeData.orientation === Orientation.LANDSCAPE) {
            this.scale.set(0.825, 0.85);

            // TODO: Needs to implement this to fit everything in 4:3
            if(resizeData.width >= 1280) {
                //this.scale.set(1, 1);
            } else {
                //this.scale.set(0.8, 0.8);
            }

            this.x = 50; //GameConfig.instance.REEL_AREA_POS_X * 1.15;
            this.y = 70; //GameConfig.instance.REEL_AREA_POS_Y * 1.15 + 120;
        }
        else {
            this.scale.set(0.9, 0.9);
            this.x = 12.5; //GameConfig.instance.REEL_AREA_POS_X;
            this.y = 95; //GameConfig.instance.REEL_AREA_POS_Y;
        }

        this.UpdateReelAreaMask();
    }

    private getMaskShape():PIXI.Graphics {
        const rect:PIXI.Rectangle = GameConfig.instance.REEL_AREA_MASK_RECT != undefined ? GameConfig.instance.REEL_AREA_MASK_RECT :
            new PIXI.Rectangle(GameConfig.instance.REEL_AREA_POS_X, GameConfig.instance.REEL_AREA_POS_Y,
                GameConfig.instance.REEL_AREA_WIDTH, GameConfig.instance.REEL_AREA_HEIGHT);
        const maskShape = new PIXI.Graphics();
        maskShape.beginFill(0xFFFFFF, 1);
        maskShape.drawRect(rect.x - GameConfig.instance.REEL_AREA_POS_X, rect.y - GameConfig.instance.REEL_AREA_POS_Y + 4, rect.width, rect.height-4);
        maskShape.endFill();
        return maskShape;
    }

    protected UpdateReelAreaMask():void {
        if(GameConfig.instance.REEL_AREA_MASK === false) {
            return;
        }

        if(this._baseMask) {
            this._baseMask.parent.removeChild(this._baseMask);
        }
        this._baseMask = this.getMaskShape();
        this.addChild(this._baseMask);
        this.mask = this._baseMask;

        //super.UpdateReelAreaMask();
    }
}